import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Style from "./index.module.css";

export const CookieConsent = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [showPdf, setShowPdf] = useState(false);

  const cookieName = user ? `cookieConsent_${user.codope}` : "cookieConsent";

  const getCookie = (name) =>
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];

  useEffect(() => {
    if (!getCookie(cookieName)) setOpen(true);
  }, [cookieName]);

  const accept = () => {
    const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
    document.cookie = `${cookieName}=true; expires=${expires}; path=/`;

    setOpen(false);
    setShowPdf(false);
  };

  if (!open) return null;

  return (
    <>
      <div className={Style.banner}>
        <p>
          Este site utiliza cookies para melhorar sua experiência.
          Antes de continuar, leia os Termos de Conduta para Fornecedores.
        </p>

        <div className={Style.actions}>
          <button onClick={() => setShowPdf(true)}>Ver Termos</button>
        </div>
      </div>

      {showPdf && (
        <div className={Style.overlay}>
          <div className={Style.modal}>
            <header>
              <h3>Termos de Conduta para Fornecedores</h3>
            </header>

            <iframe
              src="/termos-conduta.pdf"
              className={Style.pdf}
              title="termos-conduta"
            />

            <footer className={Style.modalActions}>
              <button onClick={() => setShowPdf(false)}>Fechar</button>
              <button onClick={accept}>Aceitar Termos</button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};
